import { AbugidaDevanagariIcon } from './AbugidaDevanagariIcon';

/**
 * author: Haley Halcyon
 * id E211A028-22EA-4A78-9306-FC8FF8494D02
 * name abugida-devanagari
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abugida-devanagari.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemDevanagariIcon = AbugidaDevanagariIcon;
export default WritingSystemDevanagariIcon